document.addEventListener("DOMContentLoaded", function() {
    const moreBtn = document.querySelector(".ocg-revw-mr-btn");
    const reviews = document.querySelectorAll(".ocg-revws-bx-rpt");
    
    moreBtn.addEventListener("click", function() {
        reviews.forEach(function(review) {
            review.style.display = "block"; // Show all hidden reviews
        });
        moreBtn.style.display = "none"; // Hide the "More" button after click
    });
    if (typeof jQuery !== "undefined") {

        $(".cst-btn").on("click", function (e) {
            e.preventDefault();

            var target = $("#cstm-contact-form");

            if (target.length) {
                $("html, body").animate({
                    scrollTop: target.offset().top
                }, 2000);
            } else {
                console.warn("Target section not found: #cstm-contact-form");
            }
        });

    } else {
        console.error("jQuery not loaded");
    }
   
});